function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export var theme = {
    borders: {
        solid: "1px solid"
    },
    breakpoints: [
        "48em",
        "64em",
        "75em"
    ],
    colors: {
        blues: {
            100: "#d3e9fc",
            50: "#f0f7ff"
        },
        brands: {
            blue: "#80c7f5",
            danger: "#e61d1d",
            magenta: "#d6219c",
            purple: "#871eff",
            success: "#1c8731",
            warning: "#fa9f00"
        },
        connotations: {
            alert: "#e61d1d",
            cta: "#871eff",
            info: "#80c7f5",
            primary: "#000000",
            success: "#1c8731"
        },
        greys: {
            0: "#ffffff",
            100: "#efefef",
            1000: "#000000",
            200: "#e6e6e6",
            300: "#cccccc",
            400: "#999999",
            50: "#f9f9f9",
            500: "#666666",
            700: "#4d4d4d",
            800: "#333333",
            900: "#222222"
        },
        purples: {
            100: "#d3c1fc",
            300: "#cba1fa",
            700: "#6405D1"
        }
    },
    fontSizes: {
        lg: 20,
        md: 16,
        sm: 14,
        xl: 32,
        xs: 12
    },
    fontWeights: {
        600: 600,
        medium: 500
    },
    lineHeights: {
        lg: 2.3,
        md: 1.6
    },
    radii: {
        lg: 10,
        md: 6,
        sm: 4,
        xl: 16,
        xs: 2
    },
    sizes: {
        sm: 24
    },
    space: {
        lg: 24,
        md: 16,
        sm: 8,
        xl: 32,
        xs: 4
    },
    transition: {
        fast: "all 200ms ease-out",
        medium: "all 400ms ease-out"
    }
};
export var darkTheme = _object_spread_props(_object_spread({}, theme), {
    accentColor: theme.colors.greys[100],
    accentColorActive: theme.colors.greys[0],
    primaryColor: theme.colors.greys[1000],
    primaryColorHover: theme.colors.greys[800],
    primaryColorNeutral: theme.colors.greys[700],
    primaryColorSurface: theme.colors.greys[900]
});
export var lightTheme = _object_spread_props(_object_spread({}, theme), {
    accentColor: theme.colors.greys[900],
    accentColorActive: theme.colors.greys[1000],
    primaryColor: theme.colors.greys[0],
    primaryColorHover: theme.colors.greys[200],
    primaryColorNeutral: theme.colors.greys[300],
    primaryColorSurface: theme.colors.greys[100]
});

//# sourceMappingURL=theme.js.map